<template>
  <div>
    <navHeader />
    <div class="container-lg mt-5">
 <div class="row">
        <div class="col-12 col-md-12 col-lg-12">
          <div class="p-3">
            <h2 class="main-title">
               <h2 class="main-title text-center">Share Buy-Back</h2>
            </h2>
 
            <h5 class="main-title text-center"> {{ shareBuyback.title }}</h5>
      <p class="text-muted text-right">As of {{ FormatDate(shareBuyback.date) }}</p>  
            <div class="table-responsive mt-3">
            <table class="table secondary-table table-bordered text-nowrap" v-if="!isDataLoaded">
                <thead>
                  <tr>
                    <th>COMPANY TICKER</th>
                    <th>COMPANY</th>
                    <th>OUTSTANDING SHARES</th>
                    <th>TOTAL SHARES BOUGHT</th>
                    <th>TOTAL AMOUNT(PHP)</th>
                    <th>AVERAGE PRICE</th>
                    <th>BUY-BACK FUND(PHP)</th>
                    <th>BALANCE (PHP)</th>
                    <th>COMPLETED (%) </th>
                    <th> % OF TOTAL O/S*</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in generateList(shareBuyback.shareBuybackList)[currentPage -1]" :key="index">
                    <td>
                      <b>{{ item.companyTicker }}</b>
                    </td>
                    <td>{{ item.company }}</td>
                    <td class="text-right">{{ FormatYield(item.outstandingShares) }}</td>
                    <td class="text-right">{{ FormatYield(item.totalSharesBought)}}</td>
                    <td class="text-right">{{ FormatYield(item.totalAmount) }} </td>
                    <td class="text-right">{{FormatPrices(item.averagePrice) }} </td>
                    <td class="text-right">{{FormatYield(item.buybackFund) }} </td>
                    <td class="text-right">{{ FormatYield(item.balance) }} </td>
                     <td class="text-right">{{ FormatYield(item.completed)}} </td>
                   <td class="text-right">{{ FormatYield(item.total)}} </td> 
                  </tr>
                </tbody>
              </table>
            </div>
              <div v-if="shareBuyback.shareBuybackList.length == 0 && !isDataLoaded">
                   <Noresult/>
              </div> 
             <p class="text-muted"> {{shareBuyback.source }}</p>

                <b-skeleton-table
                :rows="20"
                :columns="8"
                :table-props="{ bordered: true, striped: true }"
                 v-if="isDataLoaded"
              ></b-skeleton-table>


             <div class="d-flex justify-content-center mt-5" v-if="shareBuyback.shareBuybackList.length != 0">
              <b-pagination
                size="lg"
                v-model="currentPage"
                :total-rows="this.shareBuyback.shareBuybackList.length"
                 :per-page="perPage"
             
              ></b-pagination>
            </div>
          
          </div>
        </div>
      </div> 

      <a href="javascript:void(0)" @click="ViewArchive()"> View ShareBuyback  archive </a>

      <Disclaimer />
    </div>
    <Footer />
  </div>
</template>

<script>
import navHeader from "../../ResearchPages/NavHeader";
import Disclaimer from "../ReportsPages/Disclaimer";
import { mapState } from "vuex";
import Footer from "../Footer";
import moment from "moment";
import Noresult from "../NoResult.vue";
export default {
  components: {
    Disclaimer,
    navHeader,
    Footer,
    Noresult
  },

  data() {
    return {
      perPage:30,
      currentPage:1,
      isDataLoaded:false
    };
  },
  computed: {
    ...mapState({
      reports: (state) => state.philstocksResearch.ReportsContent,
      shareBuyback: (state) => state.philstocksResearch.sharesBuyback,
    }),
  },
  methods: {
     GoogleAnalytics() {
      this.$gtag.event("ShareBuyback", { method: "Google" });
    },

     FormatYield(data) {
      var price = parseFloat(data);
      if (isNaN(price) || price == 0) {
        return 0;
      } else {
        return price.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
    },

FormatPrices(data) {
      var price = parseFloat(data);
      if (price == 0) {
        return price.toLocaleString("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
      } else if (price < 0.51) {
        return price.toLocaleString("en-US", {
          minimumFractionDigits: 4,
          maximumFractionDigits: 4,
        });
      } else if (price >= 1000) {
        return price.toLocaleString("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
      } else {
        return price.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
    },

     generateList(data) {
      var list = 30; // items per list

      var result = data.reduce((resultArray, item, index) => {
        const listIndex = Math.floor(index / list);

        if (!resultArray[listIndex]) {
          resultArray[listIndex] = []; // start a new list
        }

        resultArray[listIndex].push(item);

        return resultArray;
      }, []);

      return result;
    },
    ViewArchive() {
      this.$router.push("/Reports/Archive/SharesBuyback");
    },
    FormatDate(date) {
      var result = "";
      if (date == "0001-01-01T00:00:00") {
        result = "--";
      } else {
        result = moment(date).format("MMMM DD, YYYY");
      }
      return result;
    },

     async GetSharesBuybackContent(data) {
      var isResponseError = false;
      this.isDataLoaded = true;
      var _this = this;
      await this.$store
        .dispatch("philstocksResearch/GetSharesBuyback", data)
        .catch(function (error) {
          console.log(error);
          _this.isDataLoaded = false;

          isResponseError = false;
        });

      if (!isResponseError) {
        _this.isDataLoaded = false;
      }
    },
  },
  async mounted() {
    this.GetSharesBuybackContent(this.$route.query.date);
  },
};
</script>

<style></style>
